import { isEmpty, isUndefined, forEach, sortBy, isObjectLike } from 'lodash';
import { fromJS, List } from 'immutable';

import { mergeModelTrimsBitField } from 'commons-vehicle/ModelYear/services/DataUtilitiesService/DataUtilitiesService.js';
import * as DataOrigins from 'commons-vehicle/constants/dataOrigins.js';
import {
    getIconFromFeatureCode,
    getFeatureIcons,
} from 'commons-vehicle/ModelYear/services/ModelTrimItemsService/ModelTrimItemsService.js';
import ModelTrimModel from 'commons-vehicle/ModelYear/models/ModelTrimModel.js';
/* eslint no-bitwise: 0 */

function getModelTrimFeatureIcons(configurationFeatureIcons) {
    const featureIcons = {};
    forEach(configurationFeatureIcons.toArray(), (featureIcon) => {
        if (featureIcon.isFromModelTrim && isUndefined(featureIcons[featureIcon.iconObject.code])) {
            featureIcons[featureIcon.iconObject.code] = featureIcon;
        }
    });

    return featureIcons;
}

function getModelTrimAddFeatureRankedIcons(features, modelTrimFeatures, comparisonAddFeatures) {
    const modelTrimAddFeatureRankedIcons = [];
    const modelTrimCompareFeatureIcons = getFeatureIcons(comparisonAddFeatures);

    forEach(modelTrimCompareFeatureIcons, (iconType, iconTypeKey) => {
        forEach(iconType.featureCodes, (featureCode) => {
            const iconCode = iconType.iconCode || iconTypeKey;
            modelTrimAddFeatureRankedIcons.push(
                fromJS(getIconFromFeatureCode(features, modelTrimFeatures, iconType, iconCode, featureCode))
            );
        });
    });

    return sortBy(modelTrimAddFeatureRankedIcons, (rankedIcon) => {
        return rankedIcon.get('rank');
    });
}

function resetModelTrimFromModelData(modelData) {
    return new ModelTrimModel({
        trimCode: modelData.configuration.modelTrimCode,
        trimsBitField: modelData.configuration.modelTrim.trimsBitField,
        trimsBitFields: modelData.configuration.modelTrim.trimsBitFields,
        selectionCode: modelData.configuration.modelTrim.code,
        enabled: true,
        visible: true,
        selected: false,
        userSelected: false,
        code: modelData.configuration.modelTrim.code,
        description: modelData.configuration.modelTrim.description,
        trimExtensionCode: modelData.configuration.modelTrim.extensionCode,
        trimExtensionDescription: modelData.configuration.modelTrim.extensionDescription,
        rank: modelData.configuration.modelTrimRank,
        configurationIds: {},
        features: modelData.configuration.modelTrimFeatures,
        featureIcons: getModelTrimFeatureIcons(modelData.configuration.featureIcons),
        comparisonModelTrimCode: '',
        comparisonModelTrim: '',
        comparisonModelTrimExtension: '',
        comparisonAddFeatures: {},
        comparisonRemoveFeatures: {},
        comparisonAddFeatureIcons: {},
    });
}

export function resetModelTrimFromOriginData(dataOrigin, originModelTrimData) {
    if (isEmpty(originModelTrimData) || !isObjectLike(originModelTrimData)) {
        return new ModelTrimModel();
    }

    switch (dataOrigin) {
        case DataOrigins.MODELS_COLLECTION:
            return new ModelTrimModel();

        case DataOrigins.MODEL_YEAR_POWERS_TRIMS:
            return resetModelTrimFromModelData(originModelTrimData);

        default:
            return new ModelTrimModel();
    }
}

export function addModelTrimConfigurationId(modelTrim, configurationId, configuration) {
    const { trimsBitField, trimsBitFields } = mergeModelTrimsBitField(modelTrim, configuration, true);
    const configurationIds = modelTrim.get('configurationIds');
    configurationIds[configurationId] = configuration.trimsBitField;

    return modelTrim
        .set('trimsBitField', trimsBitField)
        .set('trimsBitFields', trimsBitFields)
        .set('configurationIds', configurationIds);
}

export function resetModelTrimComparisonFeatures(prevTrimID, prevTrim, prevTrimExtension, prevTrimFeatures, modelTrim) {
    let compareModelTrim = modelTrim;

    const comparisonAddFeatures = {};
    const comparisonAddFeatureIcons = {};
    const comparisonRemoveFeatures = {};

    forEach(modelTrim.features, (feature, key) => {
        comparisonAddFeatures[key] = feature;
        if (!isEmpty(modelTrim.featureIcons) && !isUndefined(modelTrim.featureIcons[key])) {
            comparisonAddFeatureIcons[key] = modelTrim.featureIcons[key];
        }
    });

    if (!isEmpty(prevTrimFeatures)) {
        compareModelTrim = compareModelTrim
            .set('comparisonModelTrimCode', prevTrimID)
            .set('comparisonModelTrim', prevTrim)
            .set('comparisonModelTrimExtension', prevTrimExtension);

        forEach(prevTrimFeatures, (prevTrimFeature, prevTrimKey) => {
            if (!isEmpty(comparisonAddFeatures[prevTrimKey])) {
                delete comparisonAddFeatures[prevTrimKey];
                if (
                    !isEmpty(compareModelTrim.featureIcons) &&
                    !isUndefined(compareModelTrim.featureIcons[prevTrimKey])
                ) {
                    delete comparisonAddFeatureIcons[prevTrimKey];
                }
            } else {
                comparisonRemoveFeatures[prevTrimKey] = prevTrimFeature;
            }
        });

        forEach(comparisonAddFeatures, (comparisonFeature, comparisonFeatureKey) => {
            if (!isEmpty(prevTrimFeatures[comparisonFeatureKey])) {
                delete comparisonAddFeatures[comparisonFeatureKey];
            }
        });
    }

    return compareModelTrim
        .set('comparisonAddFeatures', comparisonAddFeatures)
        .set(
            'comparisonAddFeatureIcons',
            List(
                getModelTrimAddFeatureRankedIcons(
                    modelTrim.features,
                    modelTrim.modelTrimFeatures,
                    comparisonAddFeatures
                )
            )
        )
        .set('comparisonRemoveFeatures', comparisonRemoveFeatures);
}

export default {
    getModelTrimFeatureIcons,
    getModelTrimAddFeatureRankedIcons,
    resetModelTrimFromModelData,
    resetModelTrimFromOriginData,
    addModelTrimConfigurationId,
    resetModelTrimComparisonFeatures,
};
